import { IHierarchyAPIQuery, HierarchyLevelType, IDesign } from 'common/interfaces/hierarchy-entities';
import { apiCallBegan } from 'client/store/middleware/api/api';
import {
  HierarchyEntityName, deleteHierarchyEntityAPICallAction, getHierarchyEntitiesAPICallAction, getHierarchyEntityAPICallAction, postHierarchyEntityAPICallAction,
} from '../helpers/hierarchy-api-actions-factory';
import { createHierarchyEntitySlice } from '../../hierarchy-state-slice-factory';

const slice = createHierarchyEntitySlice<IDesign>(HierarchyLevelType.Design);

export const {
  itemsRequested: designsRequested,
  itemsRecieved: designsRecieved,
  itemsFailed: designsFailed,
  itemRecieved: designRecieved,
  itemDeleteRecieved: designsDeleteRecieved,
  itemUpdated: designUpdated,
} = slice.actions;

export default slice.reducer;

export const getDesigns = (params: Partial<IHierarchyAPIQuery>) => getHierarchyEntitiesAPICallAction(HierarchyEntityName.DESIGN, params, designsRequested.type, designsFailed.type, designsRecieved.type);

export const getDesign = (entityId: string, parentId: string) => getHierarchyEntityAPICallAction(HierarchyEntityName.DESIGN, { entityId, parentId }, designsRequested.type, designsFailed.type, designRecieved.type);

export const createDesign = (data: Partial<IDesign>) => postHierarchyEntityAPICallAction(HierarchyEntityName.DESIGN, data, designsRequested.type, designsFailed.type, designRecieved.type);

export const updateDesign = (data: Partial<IDesign> & { nodeid: string }, onAfterSuccess: () => void) => {
  return (dispatch: any) => {
    return dispatch(apiCallBegan({
      url: `/archive/${data.designid}?type=${HierarchyEntityName.DESIGN}`,
      method: 'PUT',
      data,
      toastOnError: true,
      onStart: () => ({ type: designsRequested.type, payload: { parentId: '' } }),
      onAfterSuccess,
      onSuccess: (response: { id: string }) => {
        dispatch(designUpdated(data));
        return {
          type: designsRequested.type,
          payload: response,
        };
      },
      onError: (e: any) => ({ type: designsFailed.type, payload: { parentId: '', message: e.message } }),
    }));
  };
};

export const deleteDesign = (data: Partial<IDesign>) => deleteHierarchyEntityAPICallAction(HierarchyEntityName.DESIGN, data.designid!, designsRequested.type, designsFailed.type, designsDeleteRecieved.type);

export const syncDesigns = (designids: string[]) => apiCallBegan({
  url: `/design/sync`,
  method: 'POST',
  data: { designids },
  toastOnSuccess: true,
  toastOnError: true,
  successTitle: 'Start synching',
  successMessage: 'Syncing design between archive and wd',
});
